import { ENTITY_TYPE_INDIVIDUAL } from '../shared/useOnboardingState';

export function getEinValidationError({ entityType, ein }) {
  if (entityType === ENTITY_TYPE_INDIVIDUAL) return '';
  const einDigits = (ein || '').replace(/\D/g, '');
  if (!einDigits) {
    return 'Please enter your EIN.';
  }
  if (einDigits.length !== 9) {
    return 'Please enter a valid 9-digit EIN.';
  }
  return '';
}

export function buildNonprofitLookupPayload({ entityType, ein, orgName, einLookupStatus }) {
  if (entityType === ENTITY_TYPE_INDIVIDUAL || einLookupStatus === 'found') return null;
  const einDigits = (ein || '').replace(/\D/g, '');
  if (einDigits.length === 9) return { ein: einDigits };
  const trimmedOrgName = (orgName || '').trim();
  if (!trimmedOrgName) return null;
  return { query: trimmedOrgName };
}

